<!--<small class="debug">{{me}}</small><br/>-->
<div [@fadeIn]="getState()">
    <router-outlet></router-outlet>
</div>
